module.exports = __webpack_public_path__ + "img/15.ea3a37e5.png";